// @styles
require('./insertEntityCredentialsView.scss')

// @vendors
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

// @components
import WizardSuccess from 'components/commons/wizardSuccess/wizardSuccess';

// @utilities
import { PROC_ADD_ENTITY } from 'utilities/tagging';
const { formatText, FormattedText } = require('core/i18n').i18n;

function InsertEntityCredentialsSuccessView({ bankName, bankLogo, onMainButtonClick, onSecondaryButtonClick, history }) {

    return (
        <div className="insert-entity-credentials col-xs-offset-1 col-xs-10">
            <WizardSuccess
                successMessage={formatText('aggregatorAddEntitySuccess-title', [bankName])}
                mainButton={{
                    label: (<FormattedText value={'aggregatorAddEntitySuccess-button'}/>)
                }}
                onMainButtonClick={onMainButtonClick}
                secondaryButton={{
                    label: (<FormattedText value={'aggregatorAddEntitySuccess-secondaryButton'}/>)
                }}
                onSecondaryButtonClick={() => onSecondaryButtonClick(history)}
                processType={PROC_ADD_ENTITY}
            >
                <FormattedText value={`aggregatorAddEntitySuccess-text`} injectedStrings={[bankName]} />
                <div className="insert-entity-credentials__div-img">
                    <img className="insert-entity-credentials__img" src={bankLogo} />
                </div>
            </WizardSuccess>
        </div>
    );
}

const handleOnClickSecondaryButton = (history) => {
    history.push('/myprofile/global')
}

InsertEntityCredentialsSuccessView.propTypes = {
    bankName: PropTypes.string,
    bankLogo: PropTypes.string,
    onMainButtonClick: PropTypes.func,
    onSecondaryButtonClick: PropTypes.func,
    history: PropTypes.object.isRequired,
}

InsertEntityCredentialsSuccessView.defaultProps = {
    onMainButtonClick: () => {},
    onSecondaryButtonClick: (history) => handleOnClickSecondaryButton(history),
}

export default withRouter(InsertEntityCredentialsSuccessView);
